import { useEffect, useState } from 'react';
import CityService from '../../../services/city_service';
import { getCountryIdByName } from '../utils/formHelpers';
import Permissions from './Permissions';
import Catalogs from './Catalogs';
import Accordions from './Accordions';
import Forms from './Forms';
import LoadUser from './LoadUser';
import Submit from './submit/Submit';

const Form = (vm) => {
  const [user, setUser] = useState(vm.userlogin);
  const permissionState = Permissions(vm.permissions);
  const catalogs = Catalogs({
    canAssignRole: permissionState.canAssignRole,
    isEditorRoleAdministrator: permissionState.isEditorRoleAdministrator,
    message: vm.message
  });

  const accordions = Accordions(vm.losesAccess);

  const forms = Forms({
    mode: vm.mode,
    userlogin: vm.userlogin,
    user,
    roles: catalogs.roles,
    isReaderRole: permissionState.isReaderRole,
    canAssignRole: permissionState.canAssignRole,
    losesAccess: vm.losesAccess,
  });

  const [cities, setCities] = useState([]);

  useEffect(() => {
    let active = true;

    const loadCities = async () => {
      const countryId = forms.formDataUser.country;
      if (!countryId) {
        setCities([]);
        return;
      }
      try {
        const data = await CityService.getByCountry(countryId);
        if (active) setCities(data ?? []);
      } catch (e) {
        if (active) {
          setCities([]);
          vm.message(e?.message || e, "error");
        }
      }
    };

    loadCities();
    return () => {
      active = false;
    };
  }, [forms.formDataUser.country]);

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    forms.setFormDataUser((prev) => ({
      ...prev,
      cityId,
    }));
  };

  LoadUser({
    user,
    mode: vm.mode,
    logout: vm.logout,
    setUser,
    setFormDataUser: forms.setFormDataUser,
    setFormDataProfesional: forms.setFormDataProfesional,
    setFormDataEstudiante: forms.setFormDataEstudiante,
    setFormDataArea: forms.setFormDataArea,
    message: vm.message
  });

  const submitState = Submit({
    mode: vm.mode,
    permissions: vm.permissions,
    userlogin: vm.userlogin,
    roles: catalogs.roles,
    acceptedPolicy: forms.acceptedPolicy,
    formDataUser: forms.formDataUser,
    formDataProfesional: forms.formDataProfesional,
    formDataEstudiante: forms.formDataEstudiante,
    formDataArea: forms.formDataArea,
    logout: vm.logout,
    message: vm.message,
    onBackToLogin: vm.onBackToLogin,
    onClose: vm.onClose,
    closeActive: vm.closeActive,
    losesAccess: vm.losesAccess,
    setLoading: forms.setLoading,
    resetAll: forms.resetAll,
    setUser,
  });

  const modified = async (e) => {
    e.preventDefault();
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    setUser(null);
  };

  const desModified = async (e) => {
    e.preventDefault();
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    setUser(vm.userlogin);
  };

  return {
    ...permissionState,
    ...catalogs,
    ...accordions,
    ...forms,
    ...submitState,
    cities,
    user,
    setUser,
    modified,
    desModified,
    handleCityChange,
    countryName: (name) => getCountryIdByName(catalogs.countries, name),
  };
};

export default Form;
